"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.tabBarClassNames = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Badge = _interopRequireDefault(require("../Badge"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // exporting defaults so consumers can extend it


var tabBarClassNames = {
  activeButton: "bg-gray-300",
  button: "rounded py-2 px-3 focus:outline-none border-0 flex flex-row items-center",
  badge: "bg-gray-400 ml-2 leading-5",
  wrapper: "flex flex-row space-x-2"
};
exports.tabBarClassNames = tabBarClassNames;

var Tab = function Tab(_ref) {
  var classNames = _ref.classNames,
      badge = _ref.badge,
      name = _ref.name,
      route = _ref.route;
  var match = (0, _reactRouterDom.useRouteMatch)(route);
  return _react.default.createElement(_reactRouterDom.Link, {
    to: route
  }, _react.default.createElement("button", {
    className: "".concat(match ? classNames.activeButton : "", " ").concat(classNames.button)
  }, name, badge && _react.default.createElement(_Badge.default, {
    className: classNames.badge
  }, badge)));
};

var TabBar = function TabBar(_ref2) {
  var _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? tabBarClassNames : _ref2$classNames,
      _ref2$tabs = _ref2.tabs,
      tabs = _ref2$tabs === void 0 ? [] : _ref2$tabs;

  var classNamesMerged = _objectSpread(_objectSpread({}, tabBarClassNames), classNames);

  return _react.default.createElement("div", {
    className: classNamesMerged.wrapper
  }, tabs.map(function (t) {
    return _react.default.createElement(Tab, _extends({
      classNames: classNamesMerged,
      key: t.route
    }, t));
  }));
};

TabBar.propTypes = {
  classNames: _propTypes.default.shape({
    activeButton: _propTypes.default.string,
    button: _propTypes.default.string,
    badge: _propTypes.default.string,
    wrapper: _propTypes.default.string
  }),
  tabs: _propTypes.default.arrayOf(_propTypes.default.shape({
    badge: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.node]),
    name: _propTypes.default.string.isRequired,
    route: _propTypes.default.string.isRequired
  }))
};
var _default = TabBar;
exports.default = _default;